import { render, staticRenderFns } from "./elevatorAnimation.vue?vue&type=template&id=357f855e&scoped=true&"
import script from "./elevatorAnimation.vue?vue&type=script&lang=js&"
export * from "./elevatorAnimation.vue?vue&type=script&lang=js&"
import style0 from "./elevatorAnimation.vue?vue&type=style&index=0&id=357f855e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f855e",
  null
  
)

export default component.exports